var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cost-reporter-beta',{attrs:{"instance":_vm.instance,"token":_vm.token,"costReportQueryServer":_vm.costReportQueryServer},on:{"failed":_vm.onFailed,"setModified":_vm.setModified,"clearModified":_vm.clearModified,"mounted":_vm.mou}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0caab760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Programs/CostReporterBeta.vue
// module id = j2cw
// module chunks = 1